export const dashboard = {
  title: 'Dashboard',
  welcome: {
    morning: 'Good morning',
    afternoon: 'Good afternoon',
    evening: 'Good evening',
    user: 'User',
    message: 'Welcome to YouCRM'
  },
  stats: {
    customers: 'Customers',
    customersDesc: 'Total registered customers',
    products: 'Products',
    productsDesc: 'Products in catalog',
    categories: 'Categories',
    categoriesDesc: 'Number of product categories',
    warehouses: 'Warehouses',
    warehousesDesc: 'Number of active warehouses',
    inventory: 'Inventory Items',
    inventoryDesc: 'Total inventory items'
  },
  inventoryOverview: 'Inventory Overview',
  totalItems: 'Total Items',
  lowStock: 'Low Stock',
  outOfStock: 'Out of Stock',
  totalValue: 'Total Value',
  recentCustomers: 'Recent Customers',
  recentProducts: 'Recent Products',
  lowStockProducts: 'Low Stock Products',
  viewAll: 'View All',
  noCustomers: 'No customers yet',
  noProducts: 'No products yet',
  noLowStock: 'All products are in stock'
};